const BedImport = () => {

    return (
        <>
            TODO
        </>
    );
};

export default BedImport;